import styled from "styled-components";
import { Tabs as BootstrapTabs } from "react-bootstrap";

export default styled(BootstrapTabs)`
  .nav-tabs {
    border-color: #c5d0dc;
    margin-left: 0;
    position: relative;
    top: 1px;
    li > a {
      border-radius: 0;
      border-color: #c5d0dc;
      background-color: #f9f9f9;
      margin-right: -1px;
      color: #999;
      padding: 7px 12px 8px;
      line-height: 18px;
      :hover,
      :focus {
        background-color: #fff;
        color: #4c8fbd;
      }
      :focus {
        outline: none;
      }
    }
    li.active > a,
    li.active > a:focus,
    li.active > a:hover {
      border-color: #c5d0dc #c5d0dc transparent;
      border-top: 2px solid #4c8fbd;
      box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.15);
      margin-top: -1px;
      z-index: 1;
      background-color: #fff;
    }
  }

  .tab-content {
    margin-bottom: 1.5em;
    border: 1px solid #c5d0dc;
    padding: 16px 12px;
  }
`;
